var COLUMNCOUNT = 12;
var MAXWIDTH = '1240px';

export { COLUMNCOUNT, MAXWIDTH };
//# sourceMappingURL=Grid.config.js.map
